/**
 * 联接方式
 * @author wangjiegj<wangjiegj@inspur.com>
 */

/**
 * 联接方式
 */
enum JoinMode {
    /**
     * 内联接
     */
    InnerJoin = 0,

    /**
     * 外联接
     */
    OuterJoin = 1,
}

export { JoinMode };
